import { TranslationObject } from './i18n/translation';

const translations: TranslationObject = {
  modalTitle: {
    id: 'modalTitle',
    nb: 'Du vil bli logget ut om 5 min',
    en: 'You will be logged out in 5 minutes',
  },
  modalText: {
    id: 'modalText',
    nb: 'Brukeren har vært inaktiv og vil bli logget ut etter 5 minutter.',
    en: 'You will be logged out of Arbeidslivsportalen due to inactivity in 5 minutes.',
  },
  modalConfirm: {
    id: 'modalConfirm',
    nb: 'Fortsett sesjon',
    en: 'Continue session',
  },
  modalCancel: {
    id: 'modalCancel',
    nb: 'Logg ut',
    en: 'Logout',
  },
};

export default translations;
